import { CoreInput } from '@components'
import { tr } from 'mmfintech-commons'

const ExpenseAdvancedTab = ({ formValues }) => {
  return (
    <div className='advanced-section'>
      <CoreInput
        type='text'
        {...formValues.registerInput('type')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.TYPE', 'Type')}
      />
      <CoreInput
        type='text'
        {...formValues.registerInput('subCategory')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.SUB_CATEGORY', 'Sub category')}
      />
      <CoreInput
        type='text'
        {...formValues.registerInput('businessUnit')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.BUSINESS_UNIT', 'Business unit')}
      />
      <CoreInput
        type='text'
        {...formValues.registerInput('paymentType')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.PAYMENT_TYPE', 'Payment type')}
      />
      <CoreInput
        type='text'
        {...formValues.registerInput('vendorName')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.VENDOR_NAME', 'Vendor name')}
      />
      <CoreInput
        type='text'
        {...formValues.registerInput('description')}
        label={tr('FRONTEND.EXPENSES.EXPENSE_MODAL.ADDITIONAL_INFORMATION', 'Additional information')}
      />
    </div>
  )
}

export default ExpenseAdvancedTab
